module.exports = ":host {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-view/home-view.component.scss
// module id = ./src/app/home-view/home-view.component.scss
// module chunks = main